import dayjs from "dayjs";
import mixpanel from "mixpanel-browser";
import TagManager from "react-gtm-module";
import storageService from "../Services/storageService";
import { shouldSendEvent } from "./utils";
import ReactPixel from "react-facebook-pixel";
import { getCrawlerInfo, isCrawler } from "./crawlerDetection";

const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};

if (typeof window?.fbq === "undefined") {
  ReactPixel.init("429545679512361", options);
}

// ReactPixel.grantConsent();

mixpanel.init("b753c4210460ed71e24176f7a61108a4");
// ADD THIS ENTIRE BLOCK after line: mixpanel.init("b753c4210460ed71e24176f7a61108a4");

// ADD THIS: Initialize GA4 gtag if not already loaded
const initializeGtag = () => {
  if (typeof window !== "undefined" && !window.gtag && shouldSendEvent) {
    // Check if gtag is already loaded by GTM, if not load it
    if (
      !document.querySelector('script[src*="googletagmanager.com/gtag/js"]')
    ) {
      // Get GA4 ID from your existing GTM setup or add your GA4 Measurement ID here
      const GA_MEASUREMENT_ID = "G-JEQNEB7MHP";

      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", GA_MEASUREMENT_ID);
    }
  }
};

// Initialize gtag
initializeGtag();

export const pixelPageView = () => {
  ReactPixel.pageView();
  const isLive = true; // storageService.get("isGHC");
  const obj = {
    content_type: "home_listing",
    content_ids: [storageService.get("hotelId")],
    city: storageService.get("city"),
    region: storageService.get("state"),
    country: storageService.get("country"),
  };
  shouldSendEvent && isLive && ReactPixel.track("ViewContent", obj);
};

const tagManagerArgs = {
  gtmId: "GTM-KGP56JZ",
};
if (shouldSendEvent) {
  TagManager.initialize(tagManagerArgs);
}

export const fireGtmEvent = (name, obj = {}) => {
  // console.log("this called when ?");

  let isLive = true;
  let obj2 = {
    themeId: 2,
    hotelName: storageService.get("hotelName"),
    userId: storageService.get("userId"),
    hotelId: storageService.get("hotelId"),
    searchParams: storageService.get("searchParams"),
    slug: storageService.get("slug"),
    source: storageService.get("source") || "Hotelzify_Fallback",
    domain: storageService.get("domain"),
    end_date: storageService.get("checkOutDate"),
    start_date: storageService.get("checkInDate"),
    currentDate: dayjs().format("YYYY/MM/DD"),
    url: window.location.href,
    locationDetails: storageService.get("locationDetails") || {},
    ghcEnabled: isLive,
    content_type: "home_listing",
    content_ids: [storageService.get("hotelId")],
    city: storageService.get("city"),
    region: storageService.get("state"),
    country: storageService.get("country"),
    userAgent: window.navigator.userAgent,
    ...obj,
  };

  const isDev =
    window.location.host.includes("localhost") ||
    window.location.host.includes("dev.hotelzify");

  if (!isDev) {
    window &&
      window?.dataLayer?.push({
        event: name,
        ...obj2,
      });
    if (window?.gtag) {
      window.gtag("event", name, obj2);
    }
    try {
      ReactPixel.trackCustom(name, obj2);
      mixpanel.track(name, obj2);
    } catch (error) {
      console.log("mixpanel err", error);
    }
  }
};

export const mixpanelConversion = (obj) => {
  let isLive = storageService.get("isGHC");
  let obj2 = {
    themeId: 2,
    hotelName: storageService.get("hotelName"),
    userId: storageService.get("userId"),
    hotelId: storageService.get("hotelId"),
    slug: storageService.get("slug"),
    source: storageService.get("source") || "Hotelzify_Fallback",
    domain: storageService.get("domain"),
    end_date: storageService.get("checkOutDate"),
    start_date: storageService.get("checkInDate"),
    currentDate: dayjs().format("YYYY/MM/DD"),
    searchParams: storageService.get("searchParams"),
    url: window.location.href,
    testId: storageService.get("testId"),
    locationDetails: storageService.get("locationDetails") || {},
    content_type: "home_listing",
    content_ids: [storageService.get("hotelId")],
    city: storageService.get("city"),
    region: storageService.get("state"),
    country: storageService.get("country"),
    ...obj,
  };
  try {
    shouldSendEvent && isLive && mixpanel.track("conversion", obj2);
  } catch (error) {
    console.log("mixpanel err", error);
  }
};

export const pixelConversion = (obj) => {
  let isLive = storageService.get("isGHC");

  let obj2 = {
    themeId: 2,
    searchParams: storageService.get("searchParams"),
    hotelName: storageService.get("hotelName"),
    userId: storageService.get("userId"),
    hotelId: storageService.get("hotelId"),
    slug: storageService.get("slug"),
    source: storageService.get("source") || "Hotelzify_Fallback",
    domain: storageService.get("domain"),
    end_date: storageService.get("checkOutDate"),
    start_date: storageService.get("checkInDate"),
    currentDate: dayjs().format("YYYY/MM/DD"),
    url: window.location.href,
    locationDetails: storageService.get("locationDetails") || {},
    content_type: "home_listing",
    content_ids: [storageService.get("hotelId")],
    city: storageService.get("city"),
    region: storageService.get("state"),
    country: storageService.get("country"),
    ...obj,
  };

  shouldSendEvent && isLive && ReactPixel.track("Purchase", obj2);
};

export const pixelHighIntent = (name) => {
  let isLive = storageService.get("isGHC");

  let obj2 = {
    themeId: 2,
    hotelName: storageService.get("hotelName"),
    userId: storageService.get("userId"),
    hotelId: storageService.get("hotelId"),
    searchParams: storageService.get("searchParams"),
    slug: storageService.get("slug"),
    source: storageService.get("source") || "Hotelzify_Fallback",
    domain: storageService.get("domain"),
    end_date: storageService.get("checkOutDate"),
    start_date: storageService.get("checkInDate"),
    currentDate: dayjs().format("YYYY/MM/DD"),
    url: window.location.href,
    locationDetails: storageService.get("locationDetails") || {},
    content_type: "home_listing",
    content_ids: [storageService.get("hotelId")],
    city: storageService.get("city"),
    region: storageService.get("state"),
    country: storageService.get("country"),
  };

  shouldSendEvent && isLive && ReactPixel.track(name, obj2);
};

export const newFBEvents = (name, obj) => {
  let obj2 = {
    content_type: "hotel",
    checkin_date: storageService.get("checkInDate"),
    checkout_date: storageService.get("checkOutDate"),
    content_ids: String(storageService.get("hotelId")),
    city: storageService.get("city") || "Bengaluru",
    region: storageService.get("state") || "Karnataka",
    country: storageService.get("country") || "India",
    ...obj,
  };

  const isDev =
    window.location.host.includes("localhost") ||
    window.location.host.includes("dev.hotelzify");

  if (isDev) {
    return;
  }
  ReactPixel.track(name, obj2);
};

export const reportStorageError = (obj) => {
  const event = "session_storage_failed";

  const isDev =
    window.location.host.includes("localhost") ||
    window.location.host.includes("dev.hotelzify");

  if (!isDev) {
    window &&
      window?.dataLayer?.push({
        event,
        ...obj,
      });
    if (window?.gtag) {
      window.gtag("event", event, obj);
    }
    try {
      ReactPixel.trackCustom(event, obj);
      mixpanel.track(event, obj);
    } catch (error) {
      console.log("mixpanel err", error);
    }
  }
};

export const trackCrawlerVisit = () => {
  const crawlerInfo = getCrawlerInfo();

  if (crawlerInfo.detected) {
    const eventData = {
      event: "crawler_visit",
      crawler_name: crawlerInfo.name,
      crawler_category: crawlerInfo.category,
      page_url: crawlerInfo.url,
      referrer: crawlerInfo.referrer,
      timestamp: crawlerInfo.timestamp,
      user_agent: crawlerInfo.userAgent,
      screen_resolution: crawlerInfo.screenResolution,
      language: crawlerInfo.language,
      hotelId: storageService.get("hotelId"),
      hotelName: storageService.get("hotelName"),
      domain: storageService.get("domain"),
    };

    const isDev =
      window.location.host.includes("localhost") ||
      window.location.host.includes("dev.hotelzify");

    if (!isDev) {
      window?.dataLayer?.push(eventData);
      if (window.gtag) {
        window.gtag("event", "crawler_visit", {
          event_category: "Bot Traffic",
          event_label: crawlerInfo.name,
          crawler_name: crawlerInfo.name,
          crawler_category: crawlerInfo.category,
          page_location: crawlerInfo.url,
          page_referrer: crawlerInfo.referrer,
          hotel_id: storageService.get("hotelId"),
          hotel_name: storageService.get("hotelName"),
          domain: storageService.get("domain"),
          user_agent: crawlerInfo.userAgent,
          screen_resolution: crawlerInfo.screenResolution,
          language: crawlerInfo.language,
        });
      }

      try {
        ReactPixel.trackCustom("crawler_visit", eventData);
        mixpanel.track("crawler_visit", eventData);
      } catch (error) {
        console.error("Error tracking crawler visit:", error);
      }
    }

    return eventData;
  }

  return null;
};

export const trackCrawlerAction = (action, additionalData = {}) => {
  if (!isCrawler()) return null;

  const crawlerInfo = getCrawlerInfo();
  const eventData = {
    event: "crawler_action",
    action: action,
    crawler_name: crawlerInfo.name,
    crawler_category: crawlerInfo.category,
    page_url: crawlerInfo.url,
    timestamp: crawlerInfo.timestamp,
    hotelId: storageService.get("hotelId"),
    hotelName: storageService.get("hotelName"),
    domain: storageService.get("domain"),
    ...additionalData,
  };

  const isDev =
    window.location.host.includes("localhost") ||
    window.location.host.includes("dev.hotelzify");

  if (!isDev) {
    window?.dataLayer?.push(eventData);
    if (window.gtag) {
      window.gtag("event", "crawler_action", {
        event_category: "Bot Interaction",
        event_label: `${crawlerInfo.name} - ${action}`,
        action: action,
        crawler_name: crawlerInfo.name,
        crawler_category: crawlerInfo.category,
        page_location: crawlerInfo.url,
        hotel_id: storageService.get("hotelId"),
        hotel_name: storageService.get("hotelName"),
        domain: storageService.get("domain"),
        ...additionalData,
      });
    }

    try {
      ReactPixel.trackCustom("crawler_action", eventData);
      mixpanel.track("crawler_action", eventData);
    } catch (error) {
      console.error("Error tracking crawler action:", error);
    }
  }

  return eventData;
};

// Track crawler room views similar to regular room_viewed events
export const trackCrawlerRoomView = (roomData = {}) => {
  if (!isCrawler()) return null;

  const crawlerInfo = getCrawlerInfo();
  const eventData = {
    crawler_name: crawlerInfo.name,
    crawler_category: crawlerInfo.category,
    page_url: crawlerInfo.url,
    timestamp: crawlerInfo.timestamp,
    event_category: "Bot Room View",
    event_label: `${crawlerInfo.name} - Room View`,
    ...roomData,
  };

  // Use fireGtmEvent to handle all tracking platforms consistently
  fireGtmEvent("crawler_room_viewed", eventData);

  return eventData;
};

// Track crawler page navigation
export const trackCrawlerPageView = (pageData = {}) => {
  if (!isCrawler()) return null;

  const crawlerInfo = getCrawlerInfo();
  const eventData = {
    crawler_name: crawlerInfo.name,
    crawler_category: crawlerInfo.category,
    page_url: crawlerInfo.url,
    page_title: document.title,
    referrer: crawlerInfo.referrer,
    timestamp: crawlerInfo.timestamp,
    event_category: "Bot Page View",
    event_label: `${crawlerInfo.name} - ${pageData.page_type || 'Page View'}`,
    ...pageData,
  };

  // Use fireGtmEvent to handle all tracking platforms consistently
  fireGtmEvent("crawler_page_viewed", eventData);

  return eventData;
};
